<template>
  <!-- <div class="text-center"> -->
  <!-- TO DO.  nomor mo berada diatas, nama mesin berada dibawahnya, dan nama produk berada diurutan ke3 serta nomor lot diletakan paling bawah-->
  <!-- TO DO. nomor mo dibuat bold dengan size lebih kecil dari nama mesin dan nama produk, nama mesin lebih besar dari nama produk -->
  <!-- TO DO. tidak perlu menyisipkan label kolom, buat saja agar simple dan semenarik mungkin -->
  <!-- TO DO. buat agar card memiliki sedikit shadow agar tidak terlihat flat -->
  <v-dialog
    v-model="dialog"
    @click:outside="clickOutside"
    max-width="620"
    persistent
    scrollable
    overlay-color="#000"
    overlay-opacity="0.15"
  >
    <template v-slot:activator="{ on, attrs }">
      <p id="manufactureListId" v-bind="attrs" v-on="on" @click="getData"></p>
    </template>
    <v-card
      class="mo-dialog-card rounded-xl elevation-3 neo-surface"
      style="position: relative; height: 85vh; overflow: hidden"
    >
      <v-toolbar dense flat class="mo-toolbar">
        <v-toolbar-title class="mo-title white--text d-flex align-center">
          <v-icon left color="white" class="mr-2">mdi-factory</v-icon>
          LIST MANUFACTURING ORDER
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon small @click="closeDialog" class="white--text">
          <v-icon small color="white">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text
        class="pt-4 mo-dialog-body neo-surface"
        style="height: calc(85vh - 48px); overflow-y: auto"
      >
        <v-row class="px-6 px-md-8">
          <v-col cols="12" v-if="!moListData || moListData.length === 0">
            <div class="text-center grey--text text--darken-1">
              Data tidak tersedia
            </div>
          </v-col>
          <v-col
            v-for="(item, index) in moListData"
            :key="index"
            cols="12"
            md="12"
          >
            <v-card
              class="elevation-1 rounded-lg mo-card mo-card-width mx-auto"
              :ripple="true"
              @click="onCardClick(item)"
            >
              <v-card-text class="py-3 mo-card-body">
                <!-- Nomor MO (atas) -->
                <div class="mo-number">
                  {{ item.name }}
                </div>

                <!-- Shift chip positioned absolute top-right -->
                <v-chip
                  color="primary"
                  text-color="white"
                  label
                  class="mo-shift"
                >
                  {{ twoWords(item.shift_name) }}
                </v-chip>

                <!-- Nama mesin (kedua) -->
                <div class="mt-1 mo-machine">
                  {{ (item.mesin_name || '-') | uppercase }}
                </div>

                <!-- Nama produk (ketiga) -->
                <div class="mo-product mt-1">
                  {{ (item.product_name || '-') | uppercase }}
                </div>
                <!-- Nomor lot (keempat) -->
                <div class="mo-product mt-1">
                  {{ item.code_production || '-' }}
                </div>

                <!-- Status (paling bawah) -->
                <div class="mo-lot mt-2" :style="`color: ${statusInfo(item.state).color}`">
                  {{ (item.state || '-') | uppercase }}
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
  <!-- </div> -->
</template>
<script>
export default {
  name: 'ManufactureList',
  props: ['moListData'],
  components: {},
  data() {
    return {
      dialog: false
    }
  },
  filters: {
    uppercase(val) {
      return typeof val === 'string' ? val.toUpperCase() : val
    }
  },
  methods: {
    twoWords(val) {
      const s = typeof val === 'string' ? val.trim() : ''
      if (!s) return 'Shift -'
      const parts = s.split(/\s+/)
      return parts.slice(0, 2).join(' ')
    },
    getData() {
      // Open dialog when activator is clicked programmatically
      this.dialog = true
    },
    clickOutside() {
      console.log('outside')
    },
    onCardClick(item) {
      // Emit selection so parent can fetch detail/use it
      this.$emit('openDetailMO', item)
      // Optionally close dialog after selection
      setTimeout(() => {
        this.closeDialog()
      }, 200)
    },
    closeDialog() {
      setTimeout(() => {
        this.dialog = false
      }, 300)
    },
    statusInfo(val) {
      var raw = (val) || ''
      var s = String(raw).toLowerCase()
      // Only three MO states: draft, confirmed, done
      if (s == 'draft') return { label: 'Draft', color: 'grey darken-1' }
      if (s == 'confirmed') return { label: 'Confirmed', color: 'blue' }
      if (s == 'done') return { label: 'Done', color: 'green' }
      if (s == 'cancel') return { label: 'Cancel', color: 'red' }
      return { label: raw || '-', color: 'grey' }
    }
  }
}
</script>
<style scoped>
.neo-surface {
  --bg: #f3f6fb;
  background: var(--bg) !important;
}
.neo-input /deep/ .v-input__slot,
.neo-input >>> .v-input__slot {
  background: var(--bg);
  border-radius: 9999px !important;
  border: none !important;
  box-shadow: inset 3px 3px 6px rgba(0, 0, 0, 0.10), inset -3px -3px 6px rgba(255, 255, 255, 0.95) !important;
}
.neo-input /deep/ fieldset,
.neo-input >>> fieldset {
  border: 0 !important;
}
.neo-input /deep/ .v-text-field__details,
.neo-input >>> .v-text-field__details {
  display: none;
}
.mo-card {
  transition: box-shadow 0.15s ease, transform 0.1s ease;
}
.mo-card:hover {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08) !important;
  transform: translateY(-1px);
}

/* Typography sesuai TO DO */
.mo-number {
  /* nomor mo - bold, lebih kecil dari mesin/produk */
  font-weight: 700;
  font-size: 0.95rem;
  line-height: 1.2;
}
.mo-machine {
  /* nama mesin - paling besar */
  font-weight: 400;
  font-size: 18px;
  text-transform: uppercase;
}
.mo-product {
  /* nama produk - sedikit lebih kecil dari mesin */
  font-weight: 400;
  font-size: 16px;
  text-transform: uppercase;
}
.mo-lot {
  /* nomor lot - paling bawah, subtle */
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.85rem;
}

.mo-card-width {
  /* batasi lebar agar tidak full */
  max-width: 520px;
}

.mo-title {
  /* title jadi huruf kapital dan lebih besar */
  font-size: 1.1rem;
  letter-spacing: 0.5px;
}

/* Soft gradient toolbar */
.mo-toolbar {
  background: linear-gradient(135deg, #90caf9 0%, #a5d6a7 100%);
}

/* Dialog card wrapper (subtle background, rounded) */
.mo-dialog-card {
  background-color: #ffffff;
  border-radius: 16px;
}

/* Subtle gradient body */
.mo-dialog-body {
  background: linear-gradient(180deg, #fafcff 0%, #ffffff 70%);
}

/* Shift chip style */
.mo-shift {
  font-size: 14px !important; /* perbesar font */
  line-height: 1.1;
  padding: 3px 12px !important; /* tambahan padding */
  border-radius: 10px !important; /* lebih bulat */
  position: absolute;
  top: 7px;
  right: 7px;
  pointer-events: none; /* biar klik tetap ke card */
}
.v-chip.mo-shift {
  background: linear-gradient(135deg, #64b5f6 0%, #81c784 100%) !important;
  color: #fff !important;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

/* Ticket-like decoration */
.mo-card {
  position: relative;
  background: linear-gradient(
    180deg,
    #ffffff 0%,
    #f8fbff 100%
  ); /* soft palette */
  border: 1px solid rgba(144, 202, 249, 0.25);
  border-left: 3px solid #b3e5fc; /* aksen lembut selaras */
}
.mo-card-body {
  position: relative;
}
.mo-card::before,
.mo-card::after {
  content: '';
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  background: #eaf4ff;
  border: 1px solid rgba(144, 202, 249, 0.25);
  border-radius: 50%;
}
.mo-card::before {
  left: -9px;
}
.mo-card::after {
  right: -9px;
}

/* Perforated divider like ticket */
.mo-card-body {
  background-image: radial-gradient(
    circle,
    rgba(144, 202, 249, 0.35) 1px,
    transparent 1px
  );
  background-size: 8px 8px;
  background-repeat: repeat-x;
  background-position: 0 100%;
  padding-bottom: 14px !important;
}
</style>
